import {
  GET_NOTES,
  GET_NOTES_FAIL,
  GET_NOTES_SUCCESS,
  ADD_NEW_NOTE,
  ADD_NOTE_SUCCESS,
  ADD_NOTE_FAIL,
  UPDATE_NOTE,
  UPDATE_NOTE_SUCCESS,
  UPDATE_NOTE_FAIL,
  DELETE_NOTE,
  DELETE_NOTE_SUCCESS,
  DELETE_NOTE_FAIL,
  
} from "./actionTypes";

export const getNotes = () => ({
  type: GET_NOTES,
})

export const getNotesSuccess = notes => ({
  type: GET_NOTES_SUCCESS,
  payload: notes,
})

export const getNotesFail = error => ({
  type: GET_NOTES_FAIL,
  payload: error,
})

export const addNewNote = data => ({
  type: ADD_NEW_NOTE,
  payload: data,
})

export const addNoteSuccess = note => ({
  type: ADD_NOTE_SUCCESS,
  payload: note,
})

export const addNoteFail = error => ({
  type: ADD_NOTE_FAIL,
  payload: error,
})

export const updateNote = note => ({
  type: UPDATE_NOTE,
  payload: note,
})

export const updateNoteSuccess = note => ({
  type: UPDATE_NOTE_SUCCESS,
  payload: note,
})

export const updateNoteFail = error => ({
  type: UPDATE_NOTE_FAIL,
  payload: error,
})

export const deleteNote = data => ({
  type: DELETE_NOTE,
  payload: data,
})

export const deleteNoteSuccess = data => ({
  type: DELETE_NOTE_SUCCESS,
  payload: data,
})

export const deleteNoteFail = error => ({
  type: DELETE_NOTE_FAIL,
  payload: error,
})

